var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-text-field',_vm._b({attrs:{"dense":"","outlined":"","value":_vm.displayValue},on:{"blur":_vm.onBlur,"focus":_vm.onFocus,"input":_vm.updateValue}},'v-text-field',_vm.$attrs,false))}
var staticRenderFns = []

export { render, staticRenderFns }